// Dependencias generales
import React from "react"
import { useEffect } from 'react'

import HeliasLoading1 from '../../../img/helias-loading-01.png'
import HeliasLoading2 from '../../../img/helias-loading-02.png'

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");

// Initial config - FinalStep
const FinalStep = () => {

  useEffect(() => {    
    
    if(initialConfigCommonJS.antiBackOnboarding() === false){      
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("COMPLETED_INSTALLER")    
      document.title = "HELIAS Instalador - Configuración inicial: Creando tu cuenta de instalador..."
    }
    
  }, []);

  return (          
    <main>      

      <div className="loader initialcheck">
          <div className="first-loading" >
              <img className="mask" src={HeliasLoading2} alt=""/>
              <img src={HeliasLoading1} alt=""/>
          </div>
          <label id="labelLoaderFinalStep">Creando tu cuenta de instalador...</label>
      </div>          

    </main>
    
  )
}

export default FinalStep